"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBody = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * <mm-page-body>
 * mm-page-header 아래에서 페이지 본문을 세로로 쌓고 구획 사이 간격만 책임지는 컨테이너입니다.
 * 간격은 섹션 간격 토큰 하나로 정해지며 소비처가 고르지 않습니다.
 */
let PageBody = class PageBody extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
PageBody.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-8);
    }
  `;
PageBody = __decorate([
    (0, decorators_js_1.customElement)('mm-page-body')
], PageBody);
exports.PageBody = PageBody;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZS1ib2R5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGFnZS1ib2R5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQ7Ozs7R0FJRztBQUVJLElBQU0sUUFBUSxHQUFkLE1BQU0sUUFBUyxTQUFRLGdCQUFVO0lBU3RDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDOztBQVpNLGVBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7O0dBTWxCLENBQUE7QUFQVSxRQUFRO0lBRHBCLElBQUEsNkJBQWEsRUFBQyxjQUFjLENBQUM7R0FDakIsUUFBUSxDQWNwQjtBQWRZLDRCQUFRIn0=